import { clsx } from 'clsx'
import type { ConsiliumTurn } from '../../stores/chatStore'

const therapistBubbleClasses: Record<string, string> = {
  wendy: 'bubble-wendy',
  artem: 'bubble-artem',
  finch: 'bubble-finch',
  una: 'bubble-una',
}

const avatarRingClasses: Record<string, string> = {
  wendy: 'ring-wendy',
  artem: 'ring-artem',
  finch: 'ring-finch',
  harold: 'ring-finch',
  una: 'ring-una',
}

const speakerNames: Record<string, string> = {
  wendy: 'Венди',
  artem: 'Артём',
  finch: 'Гарольд',
  harold: 'Гарольд',
  una: 'Уна',
  user: 'Вы',
}

interface ConsiliumBubbleProps {
  turn: ConsiliumTurn
}

export default function ConsiliumBubble({ turn }: ConsiliumBubbleProps) {
  const isUser = turn.speaker === 'user'
  const speaker = turn.speaker
  const avatarSrc = isUser ? undefined : `/avatars/${speaker}.png`

  return (
    <div className={clsx('flex gap-2', isUser ? 'justify-end' : 'justify-start items-end')}>
      {/* Therapist avatar */}
      {!isUser && (
        <div
          className={clsx(
            'w-8 h-8 rounded-full overflow-hidden flex-shrink-0 ring-2',
            avatarRingClasses[speaker] || 'ring-primary-500'
          )}
        >
          <img
            src={avatarSrc}
            alt={speakerNames[speaker] || speaker}
            className="w-full h-full object-cover"
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
          />
        </div>
      )}

      <div className={clsx(
        'max-w-[600px]',
        isUser ? 'bubble-user' : therapistBubbleClasses[speaker] || 'bubble-assistant'
      )}>
        {/* Speaker name for therapist turns */}
        {!isUser && (
          <p className="text-xs font-semibold opacity-70 mb-1">
            {speakerNames[speaker] || speaker}
          </p>
        )}
        <p className="whitespace-pre-wrap">{turn.content}</p>
      </div>
    </div>
  )
}
